// extracted by mini-css-extract-plugin
export default {"addToCartControl":"t0-z","giftCard":"u0-z","btnContainer":"v0-z","cartButton":"w0-z","disabled":"x0-z"};